import PropTypes from "prop-types";
import ViewComponentsRenderer from "../../../components/campaign/viewComponents/ViewComponentsRenderer";
import { isEmptyObject, updateSweepstakesOutcomes } from "../../../utils/commons";
import { isOutcomeRuleConfigured } from "../campaignUtils";
import { RetailerConditionDisplay } from "../rulesAndOutcomes/outcomes/retailerOutcome";
import "../rulesAndOutcomes/outcomes/retailerOutcome/retailerOutcome.scss";
import { StoreConditionDisplay } from "../rulesAndOutcomes/outcomes/storeOutcome";
import "../rulesAndOutcomes/outcomes/storeOutcome/storeOutcome.scss";
import { SurveyConditionDisplay } from "../rulesAndOutcomes/outcomes/surveyOutcome";
import "../rulesAndOutcomes/outcomes/surveyOutcome/surveyOutcome.scss";
import "./activitySetup.scss";

const SURVEY_RULE_SLUG = "survey-answer-matching-rule";
const RETAILER_RULE_SLUG = "retailer-matching-rule";
const STORE_GROUP_RULE_SLUG = "store-group-matching-rule";

export const ActivityOutcomesSummary = ({ data, listSweepstakes }) => {
  // Add the outcome name to outcomesData
  const updatedOutcomesData = updateSweepstakesOutcomes(data, listSweepstakes);

  // Render outcome data based on inputSchema properties
  const renderOutcomeData = (outcome) => {
    return (
      <div className="ml-3">
        <ViewComponentsRenderer
          customComponentName={outcome.outcomeDefinition?.slug}
          data={outcome.outcomeData}
          inputSchema={outcome.outcomeDefinition?.inputSchema}
          hiddenFields={["keywords"]}
        />
      </div>
    );
  };

  // Render outcome rules
  const renderOutcomeRules = (outcomeRules) => {
    return outcomeRules.filter(isOutcomeRuleConfigured).map((rule) => {
      const slug = rule?.ruleDefinition?.slug;

      if (slug === SURVEY_RULE_SLUG) {
        if (!rule?.ruleData?.condition_display) return null;
        return (
          <SurveyConditionDisplay
            key={rule.id || "survey-condition"}
            ruleData={rule.ruleData}
            readOnly
          />
        );
      }

      if (
        slug === RETAILER_RULE_SLUG &&
        Array.isArray(rule?.ruleData?.keywords) &&
        rule.ruleData.keywords.length > 0
      ) {
        return (
          <RetailerConditionDisplay
            key={rule.id || "retailer-condition"}
            ruleData={rule.ruleData}
            readOnly
          />
        );
      }

      if (
        slug === STORE_GROUP_RULE_SLUG &&
        !!rule?.ruleData?.store_configuration &&
        Array.isArray(rule?.ruleData?.keywords) &&
        rule.ruleData.keywords.length > 0
      ) {
        return (
          <StoreConditionDisplay
            key={rule.id || "store-condition"}
            ruleData={rule.ruleData}
            readOnly
          />
        );
      }

      return (
        <div className="ml-3" key={rule.id}>
          {Object.keys(rule.ruleData).map((key) => {
            return (
              <ViewComponentsRenderer
                key={key}
                customComponentName={rule.ruleDefinition?.slug}
                data={rule.ruleData}
                inputSchema={rule.ruleDefinition?.inputSchema}
                hiddenFields={["keywords"]}
              />
            );
          })}
        </div>
      );
    });
  };

  // Main rendering of outcomes
  return (
    <div className="display-flex flex-direction-column gap-2">
      {updatedOutcomesData?.map((outcome) => (
        <div className="outcome-card" key={outcome.id}>
          {/* Outcome title */}
          <div className="outcome-title-container">
            <h3 className="campaign-name fs-14">
              {outcome?.outcomeDefinition?.name ?? outcome.name}
            </h3>
          </div>

          {/* Outcome data */}
          {!isEmptyObject(outcome?.outcomeDefinition?.uiSchema) && (
            <div>
              <div className="display-flex flex-direction-column">
                {Object.keys(outcome?.outcomeDefinition?.uiSchema).length > 0 &&
                Object.keys(outcome?.outcomeDefinition?.inputSchema).length > 0 ? (
                  renderOutcomeData(outcome)
                ) : (
                  <h5>No Data</h5>
                )}
              </div>
            </div>
          )}

          {/* Outcome rules */}
          {outcome?.outcomeRules && renderOutcomeRules(outcome.outcomeRules)}
        </div>
      ))}
    </div>
  );
};

ActivityOutcomesSummary.propTypes = {
  data: PropTypes.array,
  listSweepstakes: PropTypes.array,
};
